import { Link, NavLink, useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck, Users, Video, LayoutDashboard } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "@/components/ui/button";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const navItems =
    user?.role === "therapist"
      ? [
          { to: "/therapist", label: "Patienten", icon: Users },
          { to: "/therapist/exercises", label: "Übungen", icon: Video },
        ]
      : [{ to: "/dashboard", label: "Mein Training", icon: LayoutDashboard }];
  if (user?.is_admin) {
    navItems.push({ to: "/admin", label: "Admin", icon: ShieldCheck });
  }

  return (
    <div className="min-h-screen bg-zinc-950">
      <header className="sticky top-0 z-40 border-b border-zinc-800 bg-zinc-950/80 backdrop-blur-md">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-8">
          <Link to="/" className="flex items-center gap-2" data-testid="nav-brand">
            <img src="/logo.png" alt="Forum Erkelenz MyTraining" className="h-10 w-10 object-contain" />
            <span className="font-heading text-lg font-bold tracking-tight text-zinc-100">
              <span className="text-green-400">Forum Erkelenz</span>{" "}
              <span className="text-zinc-100">MyTraining</span>
            </span>
          </Link>
          <nav className="flex items-center gap-1 sm:gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end
                data-testid={`nav-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-accent text-primary"
                      : "text-zinc-400 hover:bg-zinc-800 hover:text-zinc-100"
                  }`
                }
              >
                <item.icon className="h-4 w-4" />
                <span className="hidden sm:inline">{item.label}</span>
              </NavLink>
            ))}
            <div className="ml-2 flex items-center gap-2 border-l border-zinc-800 pl-3">
              <span
                className="hidden text-sm font-medium text-zinc-300 md:inline"
                data-testid="nav-user-name"
              >
                {user?.name}
              </span>
              <Button
                variant="ghost"
                size="sm"
                onClick={handleLogout}
                data-testid="logout-button"
                className="text-zinc-400 hover:text-destructive"
              >
                <LogOut className="h-4 w-4" />
              </Button>
            </div>
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-6 sm:px-8 sm:py-10">{children}</main>
    </div>
  );
}
